export default "__VITE_ASSET__DfwZlEAc__"